module.exports = __webpack_public_path__ + "static/img/11szescianprostopadloscian.586c9d2c.png";